var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card card-page"},[_c('div',{staticClass:"card-body shadow"},[_c('WizardNavigator',{attrs:{"steps":_vm.steps,"routeIndexes":_vm.routeIndexes,"identifier":_vm.renterQuotationId,"identifierRouteKey":"renterQuotationId"}}),_c('div',{staticClass:"container container-cozy"},[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }